export default __webpack_public_path__ + "static/media/computerladyDellLogoRemovedM.8131b5a9.jpg";